<div #splashScreen id="splash-screen" [ngClass]="currentTheme" role="status" aria-live="polite">
  @if (state$ | async; as state) {
    <div class="splash-card">
      <img
        class="splash-logo"
        [src]="isDarkTheme ? './assets/Ao-img/alertops-wordmark-dark.svg' : './assets/Ao-img/alertops-wordmark-light.svg'"
        alt="AlertOps"
      />
      @if (getStatus(state)) {
        <p class="splash-status">{{ getStatus(state) }}</p>
      }
      <div class="splash-progress" aria-hidden="true">
        <span></span>
      </div>
    </div>
  }
</div>
